import { render, staticRenderFns } from "./SysAdmin.vue?vue&type=template&id=3e3fc7d6&"
import script from "./SysAdmin.vue?vue&type=script&lang=js&"
export * from "./SysAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports